/**
 * Utilidades puras de precio para talleres.
 * Sin efectos secundarios — fáciles de testear.
 */

/**
 * Calcula la edad en años completos a partir de una fecha de nacimiento.
 * @param {string|Date} fechaNacimiento
 * @returns {number|null} null si la fecha es inválida o no existe
 */
export const calcularEdad = (fechaNacimiento) => {
  if (!fechaNacimiento) return null;
  const fechaNac = new Date(fechaNacimiento);
  if (isNaN(fechaNac.getTime())) return null;
  return Math.floor((Date.now() - fechaNac) / (365.25 * 24 * 60 * 60 * 1000));
};

/**
 * Determina el precio final a cobrar según las reglas de negocio confirmadas.
 *
 * Adulto mayor (≥ 60 años):
 *   + vecino + valorAdultoMayor configurado  → valorAdultoMayor
 *   + vecino + valorAdultoMayor no config.   → valorVecino (si existe)
 *   + vecino + ninguno configurado           → valorParticular
 *   sin vecino (sin importar configuración)  → valorParticular
 *
 * Menor de 60 años:
 *   + vecino + valorVecino configurado       → valorVecino
 *   cualquier otro caso                      → valorParticular
 *
 * @param {object}  plan     - Objeto plan de taller.modalidadPago
 * @param {number|null} edad - Edad de la persona a inscribir (null = desconocida)
 * @param {boolean} esVecino - Tiene tarjeta vecino vigente
 * @returns {{ precio: number, tipo: 'adultoMayor'|'vecino'|'particular', descuento: number }}
 */
export const calcularPrecioFinal = (plan, edad, esVecino) => {
  const particular  = plan.valorParticular  || 0;
  const tieneAM     = (plan.valorAdultoMayor ?? 0) > 0;
  const tieneVecino = (plan.valorVecino      ?? 0) > 0;

  if (edad !== null && edad >= 60) {
    if (esVecino && tieneAM)     return { precio: plan.valorAdultoMayor, tipo: 'adultoMayor', descuento: particular - plan.valorAdultoMayor };
    if (esVecino && tieneVecino) return { precio: plan.valorVecino,      tipo: 'vecino',      descuento: particular - plan.valorVecino      };
    return                              { precio: particular,            tipo: 'particular',  descuento: 0                                 };
  }

  if (esVecino && tieneVecino) return { precio: plan.valorVecino, tipo: 'vecino',    descuento: particular - plan.valorVecino };
  return                              { precio: particular,       tipo: 'particular', descuento: 0                           };
};
